module.exports = __webpack_public_path__ + "static/img/speed-down-s.f29d880e.png";